export default __webpack_public_path__ + "static/media/image - books.89195daf.png";